import styled, { keyframes } from "styled-components";

const appear = keyframes`
  from {
    opacity: 0;
    transform: translate(-50%, -50%) translateY(8px) scale(.97);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) translateY(0) scale(1);
  }
`;

/* === 오버레이 (배경) === */
export const Overlay = styled.div`
  position: fixed; /* ✅ 부모 무시, 화면 전체 덮음 */
  inset: 0; /* top:0; right:0; bottom:0; left:0; */
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background: rgba(15, 23, 42, 0.36);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  overflow: hidden;
  pointer-events: auto;
`;

/* === 다이얼로그 === */
export const Dialog = styled.div`
  position: fixed; /* ✅ 화면(viewport) 기준으로 고정 */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* ✅ 정중앙 보정 */
  transform-origin: center;
  animation: ${appear} 160ms ease both;

  width: min(720px, calc(100vw - 32px));
  max-height: 90vh;
  overflow-y: auto;

  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  box-shadow: 0 24px 48px rgba(2, 6, 23, 0.22);
  padding: 18px;

  display: grid;
  gap: 14px;
  pointer-events: auto; /* 모달 내용 클릭 가능 */
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 800;
  color: #0f172a;
`;

export const CloseBtn = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  font-size: 18px;
  line-height: 1;
  padding: 6px 8px;
  color: #475569;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #f1f5f9;
  }
  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 2px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

export const Desc = styled.p`
  margin-top: -6px;
  font-size: 13px;
  color: #475569;
`;

export const ApiError = styled.div`
  margin-top: 4px;
  padding: 10px 12px;
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
`;

export const Form = styled.form`
  display: grid;
  gap: 12px;
`;

export const Row = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: grid;
  gap: 6px;
`;

export const Label = styled.label<{ $invalid?: boolean }>`
  font-size: 12px;
  font-weight: 700;
  color: ${({ $invalid }) => ($invalid ? "#b91c1c" : "#0f172a")};
`;

export const Input = styled.input<{ $invalid?: boolean }>`
  height: 36px;
  border-radius: 10px;
  border: 1px solid ${({ $invalid }) => ($invalid ? "#fca5a5" : "#e2e8f0")};
  padding: 0 12px;
  outline: none;
  color: #0f172a;
  background: ${({ $invalid }) => ($invalid ? "#fff7f7" : "#fff")};
  box-shadow: ${({ $invalid }) =>
    $invalid ? "0 0 0 2px rgba(239,68,68,.15)" : "none"};

  &:hover {
    background: ${({ $invalid }) => ($invalid ? "#fff4f4" : "#f8fafc")};
  }
  &:focus {
    border-color: ${({ $invalid }) => ($invalid ? "#ef4444" : "#2563eb")};
    box-shadow: 0 0 0 2px
      ${({ $invalid }) =>
        $invalid ? "rgba(239,68,68,.25)" : "rgba(37,99,235,.15)"};
  }
`;

export const FieldHint = styled.div`
  font-size: 11px;
  color: #b91c1c;
  font-weight: 700;
`;

export const Actions = styled.div`
  margin-top: 4px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const Button = styled.button`
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  font-weight: 800;
  letter-spacing: 0.01em;
  border: 1px solid transparent;
  cursor: pointer;

  &[data-variant="ghost"] {
    background: #f8fafc;
    color: #0f172a;
    border-color: #e2e8f0;
    &:hover {
      background: #eef2f7;
    }
    &:focus-visible {
      outline: 2px solid #94a3b8;
      outline-offset: 2px;
    }
  }

  &:not([data-variant]) {
    background: #2563eb;
    color: #fff;
    &:hover {
      background: #1e54c7;
    }
    &:disabled {
      opacity: 0.6;
      cursor: default;
    }
    &:focus-visible {
      outline: 2px solid rgba(37, 99, 235, 0.35);
      outline-offset: 2px;
    }
  }
`;
export const Select = styled.select`
  height: 36px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  outline: none;
  color: #0f172a;
  background: #fff;
  appearance: none;

  &:hover {
    background: #f8fafc;
  }
  &:focus {
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  }

  &:disabled {
    background: #f1f5f9;
    color: #94a3b8;
    cursor: not-allowed;
  }
`;
